export const SEO_KEYWORDS = [
"electric golf scooter immediate delivery Australia",
"local service electric golf scooters Australia",
"electric golf scooter with local warranty",
"Lectric Leisure M12-1 stock Australia",
"electric golf scooter Melbourne Sydney Brisbane",
"electric golf scooter",
"golf mobility scooter",
"golf scooter electric",
"personal golf scooter",
"golf cart alternative",
"electric scooter for golf course",
"golf course electric scooter",
"premium electric golf scooter",
"foldable golf scooter",
"portable golf scooter",
"battery powered golf scooter",
"eco friendly golf scooter",
"quiet electric golf scooter",
"stable golf scooter",
"heavy duty golf scooter",
"golf scooter with long battery life",
"electric golf scooter Australia",
"buy electric golf scooter",
"electric golf scooter for sale",
"best electric golf scooter",
"luxury golf scooter",
"golf scooter for seniors",
"golf scooter for hilly courses",
"electric scooter for golfers",
"golf scooter with seat",
"golf scooter with club holder",
"golf scooter with storage",
"compact golf scooter",
"lightweight golf scooter",
"electric golf scooter near me",
"Lectric Leisure scooter",
"Lectric Leisure electric golf scooter",
"Lectric Leisure M12-1",
"Lectric Leisure M12-3",
"Lectric Leisure ESGOLF",
"golf mobility solution",
"modern golf transportation",
"next generation golf scooter",
"zero emission golf scooter",
"silent golf scooter",
"golf scooter for private courses",
"golf scooter for resorts",
"golf scooter fleet solutions"
].join(", ");

export const COLORS = {
  primaryBg: '#2F4B3C',
  secondaryBg: '#1F332A',
  accent: '#C7A36A',
  lightSurface: '#F2EBDC',
  textPrimary: '#1E1E1C',
  border: '#9C8B73',
  darkCap: '#233D32',
  paddleGreen: '#1E3A30',
};